import { render } from "./RecentSales.vue?vue&type=template&id=3f176df4&ts=true"
import script from "./RecentSales.vue?vue&type=script&lang=ts"
export * from "./RecentSales.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__